import { render, staticRenderFns } from "./form-agronomo.vue?vue&type=template&id=28953252&scoped=true&"
import script from "./form-agronomo.vue?vue&type=script&lang=js&"
export * from "./form-agronomo.vue?vue&type=script&lang=js&"
import style0 from "./form-agronomo.vue?vue&type=style&index=0&id=28953252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28953252",
  null
  
)

export default component.exports